/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Last_4_Weeks_ExternalInputs */

const en_admin_dashboard_last_4_weeks_external = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 4 weeks External`)
};

const de_admin_dashboard_last_4_weeks_external = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte 4 Wochen extern`)
};

const es_admin_dashboard_last_4_weeks_external = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas 4 semanas externas`)
};

const fr_admin_dashboard_last_4_weeks_external = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 dernières semaines externes`)
};

const it_admin_dashboard_last_4_weeks_external = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultime 4 settimane esterne`)
};

const pt_br2_admin_dashboard_last_4_weeks_external = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas 4 semanas externas`)
};

const pl_admin_dashboard_last_4_weeks_external = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnie 4 tygodnie zewnętrzne`)
};

const hu_admin_dashboard_last_4_weeks_external = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utolsó 4 hét külső`)
};

const ro_admin_dashboard_last_4_weeks_external = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimele 4 saptamani Extern`)
};

/**
* | output |
* | --- |
* | "Last 4 weeks External" |
*
* @param {Admin_Dashboard_Last_4_Weeks_ExternalInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_last_4_weeks_external = /** @type {((inputs?: Admin_Dashboard_Last_4_Weeks_ExternalInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Last_4_Weeks_ExternalInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_last_4_weeks_external(inputs)
	if (locale === "de") return de_admin_dashboard_last_4_weeks_external(inputs)
	if (locale === "es") return es_admin_dashboard_last_4_weeks_external(inputs)
	if (locale === "fr") return fr_admin_dashboard_last_4_weeks_external(inputs)
	if (locale === "it") return it_admin_dashboard_last_4_weeks_external(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_last_4_weeks_external(inputs)
	if (locale === "pl") return pl_admin_dashboard_last_4_weeks_external(inputs)
	if (locale === "hu") return hu_admin_dashboard_last_4_weeks_external(inputs)
	return ro_admin_dashboard_last_4_weeks_external(inputs)
});
export { admin_dashboard_last_4_weeks_external as "admin.dashboard.last_4_weeks_external" }